export default "__VITE_ASSET__ByvtZOyg__"